import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=1a61b23d&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
import style0 from "./Payment.vue?vue&type=style&index=0&id=1a61b23d&prod&lang=scss"
import style1 from "./Payment.vue?vue&type=style&index=1&id=1a61b23d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61b23d",
  null
  
)

export default component.exports